import * as React from 'react';
import { Tooltip } from "react-tooltip";
import { DataItemImportance } from '../../misc/api/apiTypes';
import Condition from '../../misc/components/Condition';
import { ConfigFieldValidation } from '../validation/ConfigurableItemValidator';
import { TextBox } from './TextBoxV4';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { useFieldApi, useFieldState } from 'informedv4';
import { inputClasses } from '../validation/ValidationClasses';
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

interface ConfigFieldTextBoxWithTooltipProps {
    id: string;
    name: string;
    field: string;
    labelName?: string;
    tooltipDescription: string;
    className: string;
    disabled?: boolean;
    validated: boolean;
    validate?: any;
    required: boolean;
    itemId: ConfigurableDataItemIds;
}

export const ConfigFieldTextBoxWithTooltip = (props: ConfigFieldTextBoxWithTooltipProps): JSX.Element => {
    const {
        id,
        name,
        field,
        labelName,
        tooltipDescription,
        className,
        disabled,
        validated,
        validate,
        required,
        itemId,
    } = props;

    const { dataItemConfigurationCollection } = useCurrentStudyConfigurationContext();

    const fieldApi = useFieldApi(field);

    if (dataItemConfigurationCollection === null || dataItemConfigurationCollection === undefined)
        throw 'Fields Configurations is not set';

    const item = dataItemConfigurationCollection.find(x => x.configurableDataItemId === itemId);

    const { error, showError } = useFieldState(name);

    return <>
        <Condition test={() => item.importanceId !== DataItemImportance.NotApplicable}>
            <div className={className}>
                <label htmlFor={id}>{labelName !== null ? labelName : item.displayText}</label>&nbsp;
                <Tooltip id={id + '-tooltip'} class="tooltip" style={{ zIndex: 2500 }}>
                    {tooltipDescription}
                </Tooltip>
                <FontAwesomeIcon icon={faCircleInfo} aria-hidden="true" className="text-muted" data-tooltip-id={id + '-tooltip'} />
                <TextBox
                    field={field}
                    name={name}
                    id={id}
                    className={inputClasses(error as string)}
                    validate={validated ? validate !== null ? validate : ConfigFieldValidation(item, required, validated) : null}
                    disabled={disabled}
                />
            </div>
        </Condition>
    </>
}
